<div class="container">
  <p
    i18n="
      Story unavailable message|Informs the user that the story they are trying to access is no longer
      available.@@Storiesa144b0b4b71942b28f38297a2319c54b"
  >
    We're sorry, this story is no longer available.
  </p>
  <p
    class="align-delete-text"
    i18n="
      Removed grandparent explanation|Informs the user that the grandparent this story was based on may have been
      removed from the family tree.@@Storiesd3eb4e21c6354572beee16a54d45f9f9"
  >
    It looks like you may have removed the grandparent this story came from.
  </p>
  <p class="align-delete-text">
    <button (click)="goToStories()" class="btn-start ancBtn" type="button">
      <span
        i18n="
          Go to application button|Button to redirect the user to the application main
          page.@@Stories3b581a58d264464da2fc143b2a094222"
        >Go To <span [innerHTML]="appName"></span
      ></span>
    </button>
  </p>
</div>
